import React from "react";
import Select from "react-select";
import { MultiValue } from "react-select";
import { formatOptionLabel } from "components/shared/DirectoryPicker/optionRendering";
import { MembershipRole } from "components/shared/DirectoryPicker/types";

type Props = {
  value: MembershipRole[];
  onChange: (value: MembershipRole[]) => void;
  groupSlug: string;
  placeholder?: string;
  disabled?: boolean;
};

export default function GroupMembershipRolePicker({
  value,
  onChange,
  groupSlug,
  placeholder,
  disabled,
}: Props) {
  const group = Preload.my_groups.find((group) => group.slug === groupSlug);
  if (!group) return null;

  const options = group.membership_roles.map((role) => ({
    ...role,
    type: "membership_role" as const,
    parent_type: "group",
    parent_id: group.id,
    standalone: true,
  }));

  const handleChange = (newValue: MultiValue<MembershipRole>) => {
    onChange(Array.from(newValue));
  };

  const getOptionValue = (role: MembershipRole) => `${role.type}/${role.id}`;

  const formatMembershipRoleLabel = (role: MembershipRole) => {
    return formatOptionLabel(role);
  };

  return (
    <Select<MembershipRole, true>
      isMulti
      options={options}
      value={value}
      onChange={handleChange}
      formatOptionLabel={formatMembershipRoleLabel}
      getOptionValue={getOptionValue}
      placeholder={placeholder || I18n.t("js.member_select.membership_roles")}
      className="form-select-container"
      classNamePrefix="form-select"
      isDisabled={disabled}
      unstyled
    />
  );
}
